/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [{
  action: 'updateCustomerRunnerTicketAddonEntriesByRootId',
  message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_TICKET_ADDON_ENTRIES_BY_ROOT_ID,
  method: 'PATCH',
  path: '/customer/:customerId/runner-ticket-addon-entries/:rootId',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_TICKET_ADDON_ENTRY,
  requestSchema: requestSchemas.customerRunnerTicketAddonEntries.updateCustomerRunnerTicketAddonEntriesByRootId,
}];
